
/*
 * ! @chakra-ui/vue v0.12.0 by Jonathan Bakebwa @codebender828
 * MIT License
 * https://github.com/chakra-ui/chakra-ui-vue
 */

import { injectGlobal } from '@emotion/css';

var templateObject = Object.freeze(["\n    html {\n      line-height: 1.15;\n      -webkit-text-size-adjust: 100%;\n    }\n\n    body {\n      margin: 0;\n    }\n\n    main {\n      display: block;\n    }\n\n    h1 {\n      font-size: 2em;\n      margin: 0.67em 0;\n    }\n\n    hr {\n      box-sizing: content-box;\n      height: 0;\n      overflow: visible;\n    }\n\n    pre {\n      font-family: monospace, monospace;\n      font-size: 1em;\n    }\n\n    a {\n      background-color: transparent;\n    }\n\n    abbr[title] {\n      border-bottom: none;\n      text-decoration: underline;\n      -webkit-text-decoration: underline dotted;\n      text-decoration: underline dotted;\n    }\n\n    b,\n    strong {\n      font-weight: bolder;\n    }\n\n    code,\n    kbd,\n    samp {\n      font-family: monospace, monospace;\n      font-size: 1em;\n    }\n\n    small {\n      font-size: 80%;\n    }\n\n    sub,\n    sup {\n      font-size: 75%;\n      line-height: 0;\n      position: relative;\n      vertical-align: baseline;\n    }\n\n    sub {\n      bottom: -0.25em;\n    }\n\n    sup {\n      top: -0.5em;\n    }\n\n    img {\n      border-style: none;\n    }\n\n    button,\n    input,\n    optgroup,\n    select,\n    textarea {\n      font-family: inherit;\n      font-size: 100%;\n      line-height: 1.15;\n      margin: 0;\n    }\n\n    button,\n    input {\n      overflow: visible;\n    }\n\n    button,\n    select {\n      text-transform: none;\n    }\n\n    button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner {\n      border-style: none;\n      padding: 0;\n    }\n\n    fieldset {\n      padding: 0.35em 0.75em 0.625em;\n    }\n\n    legend {\n      box-sizing: border-box;\n      color: inherit;\n      display: table;\n      max-width: 100%;\n      padding: 0;\n      white-space: normal;\n    }\n\n    progress {\n      vertical-align: baseline;\n    }\n\n    textarea {\n      overflow: auto;\n    }\n\n    [type=\"checkbox\"],\n    [type=\"radio\"] {\n      box-sizing: border-box;\n      padding: 0;\n    }\n\n    [type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button {\n      -webkit-appearance: none !important;\n    }\n\n    input[type=\"number\"] {\n      -moz-appearance: textfield;\n    }\n\n    [type=\"search\"] {\n      -webkit-appearance: textfield;\n      outline-offset: -2px;\n    }\n\n    [type=\"search\"]::-webkit-search-decoration {\n      -webkit-appearance: none !important;\n    }\n\n    ::-webkit-file-upload-button {\n      -webkit-appearance: button;\n      font: inherit;\n    }\n\n    details {\n      display: block;\n    }\n\n    summary {\n      display: list-item;\n    }\n\n    template {\n      display: none;\n    }\n\n    [hidden] {\n      display: none !important;\n    }\n\n    html {\n      box-sizing: border-box;\n      font-family: sans-serif;\n    }\n\n    *,\n    *::before,\n    *::after {\n      box-sizing: border-box;\n    }\n\n    blockquote,\n    dl,\n    dd,\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6,\n    hr,\n    figure,\n    p,\n    pre {\n      margin: 0;\n    }\n\n    button {\n      background: transparent;\n      padding: 0;\n    }\n\n    fieldset {\n      margin: 0;\n      padding: 0;\n    }\n\n    ol,\n    ul {\n      margin: 0;\n      padding: 0;\n    }\n\n    html {\n      font-family: ", ";\n      line-height: 1.5;\n      -webkit-font-smoothing: antialiased;\n      -webkit-text-size-adjust: 100%;\n      text-rendering: optimizelegibility;\n    }\n\n    hr {\n      border-top-width: 1px;\n    }\n\n    img {\n      border-style: solid;\n    }\n\n    textarea {\n      resize: vertical;\n    }\n\n    button,\n    [role=\"button\"] {\n      cursor: pointer;\n    }\n\n    button::-moz-focus-inner {\n      border: 0 !important;\n    }\n\n    table {\n      border-collapse: collapse;\n    }\n\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      font-size: inherit;\n      font-weight: inherit;\n    }\n\n    a {\n      color: inherit;\n      text-decoration: inherit;\n    }\n\n    button,\n    input,\n    optgroup,\n    select,\n    textarea {\n      padding: 0;\n      line-height: inherit;\n      color: inherit;\n    }\n\n    pre,\n    code,\n    kbd,\n    samp {\n      font-family: ", ";\n    }\n\n    img,\n    svg,\n    video,\n    canvas,\n    audio,\n    iframe,\n    embed,\n    object {\n      vertical-align: middle;\n      display: block;\n    }\n\n    img,\n    video {\n      max-width: 100%;\n      height: auto;\n    }\n  "]);
function useTailwindPreflight(theme) {
  injectGlobal(templateObject, theme.fonts.body, theme.fonts.mono);
}

/**
 * Hey! Welcome to @chakra-ui/vue CReset
 *
 * CReset component injects global styles.
 *
 * @see Docs     https://vue.chakra-ui.com/radio
 * @see Source   https://github.com/chakra-ui/chakra-ui-vue/blob/master/packages/chakra-ui-core/src/CReset/CReset.js
 */

var defaultConfig = function defaultConfig(theme) {
  return {
    light: {
      color: theme.colors.gray[800],
      bg: undefined,
      borderColor: theme.colors.gray[200],
      placeholderColor: theme.colors.gray[400],
      fontFamily: theme.fonts.body
    },
    dark: {
      color: theme.colors.whiteAlpha[900],
      bg: theme.colors.gray[800],
      borderColor: theme.colors.whiteAlpha[300],
      placeholderColor: theme.colors.whiteAlpha[400],
      fontFamily: theme.fonts.body
    }
  };
};
/**
 * CReset component
 *
 * The CSS Reset component to reset browser styles
 *
 * @extends CBox
 * @see Docs https://vue.chakra-ui.com/getting-started
 */


var CReset = {
  name: 'CReset',
  inject: ['$chakraTheme', '$chakraColorMode'],
  computed: {
    colorMode: function colorMode() {
      return this.$chakraColorMode();
    },
    theme: function theme() {
      return this.$chakraTheme();
    },
    styleConfig: function styleConfig() {
      var _defaultConfig = defaultConfig(this.theme);

      return this.config ? this.config(this.theme, _defaultConfig) : defaultConfig(this.theme);
    }
  },
  props: {
    config: {
      type: Function,
      validator: function validator(value) {
        return typeof value === 'function';
      }
    }
  },
  created: function created() {
    var ref = this.styleConfig[this.colorMode];
    var color = ref.color;
    var bg = ref.bg;
    var borderColor = ref.borderColor;
    var placeholderColor = ref.placeholderColor;
    var fontFamily = ref.fontFamily;
    useTailwindPreflight(this.theme);
    injectGlobal({
      html: {
        lineHeight: 1.5,
        color: color,
        backgroundColor: bg,
        fontFamily: fontFamily
      },
      '*, *::before, *::after': {
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: borderColor
      },
      'input:-ms-input-placeholder, textarea:-ms-input-placeholder': {
        color: placeholderColor
      },
      'input::-ms-input-placeholder, textarea::-ms-input-placeholder': {
        color: placeholderColor
      },
      'input::placeholder, textarea::placeholder': {
        color: placeholderColor
      }
    });
  },
  render: function render() {
    return null;
  }
};

export default CReset;
